export default __webpack_public_path__ + "static/media/exemple_logo.edaa0e9e.jpeg";